export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "548.40c633cc.worker.js");
}
